import { z } from 'zod';

/**
 * A 125hz ECG signal of about 10 seconds (1250 samples) in length. Does not need to be
 * normalized as the model will handle this internally
 */
export type ECGPredictSinusRhythmRequest = number[];

export const ECGPredictSinusRhythmRequestSchema = z.object({
  isSinusRhythm: z.boolean().optional().nullable(),
  signalQuality: z.number().optional().nullable(),
});
export interface ECGPredictSinusRhythmResponse {
  /**
   * A null response means that the signal could not be delineated by NeuroKit
   */
  isSinusRhythm?: boolean | null;
  /**
   * A value between 0 and 1 and represents the quality of the input ECG signal - this matters since
   * the result will likely be unreliable if we have a low signal quality
   */
  signalQuality: number;
}
